import { render, staticRenderFns } from "./AwardRankingSponsorParts.vue?vue&type=template&id=1591a08d&scoped=true"
import script from "./AwardRankingSponsorParts.vue?vue&type=script&lang=ts"
export * from "./AwardRankingSponsorParts.vue?vue&type=script&lang=ts"
import style0 from "./AwardRankingSponsorParts.vue?vue&type=style&index=0&id=1591a08d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1591a08d",
  null
  
)

export default component.exports